// import './Interaction.css'
import React, { useState, useEffect, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import logo from "../images/logo.svg";
import axios from "../../helpers/request";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import {
  Container,
  Paper,
  Typography,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import { TimelapseOutlined, Videocam, Login, Visibility } from "@mui/icons-material";

import { DataGridPro } from "@mui/x-data-grid-pro";
// import { makeStyles } from '@mui/styles';

import styled from "@emotion/styled";
import { css } from "@emotion/react";

// import { TimelapseOutlined } from '@mui/icons-material';
// import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

// import { DataGrid } from '@mui/x-data-grid';
// import Grid from '@mui/material/Grid';

import { useAppState } from "../../state";
import InteractionIssue from "../InteractionIssue/InteractionIssue";

const SUPER_ADMIN_ROLE = "super_administrator";
const TRANSCRIPT_ROLE = "transcript";

const MainContainer = styled.main(({ theme }) => ({
  flexGrow: 1,
  minHeight: "100vh",
  overflow: "auto",
  backgroundColor: "#f8fafc",
  padding: 0,
}));

const HeaderBar = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 24px",
  backgroundColor: "#fff",
  borderBottom: "1px solid #e2e8f0",
}));

const HeaderLeft = styled.div({
  display: "flex",
  alignItems: "center",
  gap: "16px",
});

const HeaderRight = styled.div({
  display: "flex",
  alignItems: "center",
  gap: "16px",
});

const BackButton = styled.span({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  color: "#10416D",
  fontSize: "14px",
  cursor: "pointer",
  "&:hover": {
    color: "#0d3557",
  },
});

const LogoImage = styled.img({
  height: "28px",
});

const BrandName = styled.span({
  fontSize: "18px",
  fontWeight: 600,
  color: "#10416D",
  letterSpacing: "-0.5px",
});

const HeaderTitle = styled.span({
  fontSize: "13px",
  fontWeight: 500,
  color: "#10416D",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
});

const RefreshButton = styled(Button)({
  backgroundColor: "#10416D",
  color: "#fff",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "14px",
  padding: "8px 20px",
  borderRadius: "10px",
  boxShadow: "0 1px 3px rgba(16, 65, 109, 0.3)",
  "&:hover": {
    backgroundColor: "#10416D",
  },
  "&:disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    color: "#fff",
  },
});

const ContentWrapper = styled.div({
  padding: "24px 32px",
});

const OverviewCard = styled(Paper)({
  backgroundColor: "#fff",
  borderRadius: "12px",
  border: "1px solid #e2e8f0",
  padding: "24px",
  marginBottom: "24px",
  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
});

const SectionTitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  color: "#10416D",
  marginBottom: "20px",
});

const DetailsGrid = styled.div({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "24px",
  marginBottom: "24px",
});

const DetailColumn = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

const DetailRow = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

const DetailLabel = styled.span({
  fontSize: "11px",
  fontWeight: 500,
  color: "#94a3b8",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
});

const DetailValue = styled.span({
  fontSize: "14px",
  fontWeight: 400,
  color: "#334155",
});

const Badge = styled.span(({ variant }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "2px 10px",
  borderRadius: "4px",
  fontSize: "12px",
  fontWeight: 500,
  backgroundColor: variant === "yes" ? "#dcfce7" : "#fee2e2",
  color: variant === "yes" ? "#16a34a" : "#dc2626",
}));

const ButtonGroup = styled.div({
  display: "flex",
  gap: "12px",
  flexWrap: "wrap",
});

const PrimaryButton = styled(Button)({
  backgroundColor: "#10416D",
  color: "#fff",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "14px",
  padding: "10px 20px",
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "&:hover": {
    backgroundColor: "#10416D",
  },
  "&:disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    color: "#94a3b8",
  },
});

const SecondaryButton = styled(Button)({
  backgroundColor: "#10416D",
  color: "#fff",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "14px",
  padding: "10px 20px",
  borderRadius: "10px",
  border: "none",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "&:hover": {
    backgroundColor: "#10416D",
  },
  "&:disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    color: "#94a3b8",
  },
});

const ParticipantCard = styled(Paper)({
  backgroundColor: "#fff",
  borderRadius: '12px',
  border: '1px solid #e2e8f0',
  overflow: 'hidden',
  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  '& .MuiDataGrid-root': {
    border: 'none',
    borderRadius: '0px !important',
  },
});

const ParticipantHeader = styled.div({
  backgroundColor: "#f1f5f9",
  padding: "16px 24px",
  borderBottom: "1px solid #e2e8f0",
});

const ParticipantTitle = styled(Typography)({
  fontSize: "15px",
  fontWeight: 600,
  color: "#10416D",
});

const DataGridWrapper = styled.div({
  "& .MuiDataGrid-root": {
    border: "none",
    borderRadius: 0,
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#f8fafc",
    borderBottom: "1px solid #e2e8f0",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontSize: "11px",
    fontWeight: 600,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  "& .MuiDataGrid-cell": {
    fontSize: "14px",
    color: "#334155",
    borderBottom: "1px solid #f1f5f9",
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "#f8fafc",
  },
});

const FooterActions = styled.div({
  display: "flex",
  justifyContent: "center",
  padding: "24px",
});

const ViewLogsButton = styled(Button)({
  backgroundColor: "#10416D",
  color: "#fff",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "14px",
  padding: "12px 32px",
  borderRadius: "10px",
  "&:hover": {
    backgroundColor: "#10416D",
  },
});

// Keep these for backward compatibility
const Toolbar = styled.div(({ theme }) => theme.toolbar);
const ActionButton = styled(Button)(({ theme }) => theme.actionButton);
const InnerContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
}));
const DetailedTableContainer = styled(TableContainer)(({ theme }) => ({
  "&.MuiTableContainer-root": {
    overflow: "hidden",
  },
  "& .MuiTableCell-root": {
    padding: theme.spacing(1),
    borderBottom: "none",
  },
}));
const CustomTableLabel = styled(TableCell)(({ theme }) => ({
  whiteSpace: "nowrap",
  width: "30%",
}));
const CustomTableButton = styled(TableCell)(({ theme }) => ({
  width: "50%",
}));
const CustomPaper = styled(Paper)(({ theme }) => ({
  minHeight: "200px",
  "& .customRowTable": {
    "& .meeting-archive--true": {
      backgroundColor: "#FFEAE9",
    },
  },
  "& .Flip": {
    "& .MuiDataGrid-window": {
      transform: "rotateX(180deg)",
      top: "auto !important",
    },
    "& .MuiDataGrid-dataContainer": {
      transform: "rotateX(180deg)",
    },
  },
}));
const TitleSection = styled.div(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));
const centerText = css({
  textAlign: "center",
});
const CenterTypography = styled(Typography)(() => ({
  textAlign: "center",
}));
const DangetText = styled.span(({ theme }) => ({
  color: theme.palette.error.main,
}));

// const useStyles = makeStyles((theme) => ({
//   content: {
//     flexGrow: 1,
//     height: '100vh',
//     overflow: 'auto',
//     padding: theme.spacing(2)
//   },
//   container: {
//     paddingTop: theme.spacing(4),
//     paddingBottom: theme.spacing(4),
//   },
//   toolbar: theme.toolbar,
//   actionButton: theme.actionButton,
//   tableHeader: {
//     margin: '0px'
//   },
//   paper: {
//     minHeight: '200px',
//     '& .customRowTable': {
//       '& .meeting-archive--true': {
//         backgroundColor: '#FFEAE9',
//       },
//     },
//     '& .Flip': {
//       '& .MuiDataGrid-window': {
//         transform: 'rotateX(180deg)',
//         top: 'auto !important'
//       },
//       '& .MuiDataGrid-dataContainer': {
//         transform: 'rotateX(180deg)'
//       }
//     }
//   },
//   detailedTable: {
//     '&.MuiTableContainer-root': {
//       overflow: 'hidden'
//     },
//     '& .MuiTableCell-root': {
//       padding: theme.spacing(1),
//       borderBottom: 'none'
//     }
//   },
//   tableLabel: {
//     whiteSpace: 'nowrap',
//     width: '30%'
//   },
//   tableButton: {
//     width: '50%'
//   },
//   sectionTitle: {
//     paddingLeft: theme.spacing(3),
//     paddingRight: theme.spacing(3),
//     paddingTop: theme.spacing(1),
//     paddingBottom: theme.spacing(1),
//   },
//   centerText: {
//     textAlign: 'center'
//   },
//   dangerText: {
//     color: theme.palette.error.main
//   }
// }));

export default function Interaction() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [meeting, setMeeting] = useState({});
  const { meetingId } = useParams();
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [meetingBtnStatus, SetMeetingBtnStatus] = useState(true);
  const { user, userRights } = useAppState();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const TRANSCRIPT_USER = "transcripts team user";

  useEffect(() => {
    if (meetingId) {
      getMeeting(meetingId);
      getParticipants(meetingId);
    } else {
      navigate("/", { replace: true });
    }
  }, [meetingId, navigate, count]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(count + 1);
    }, 60000);

    return () => clearInterval(interval);
  }, [count]);

  useEffect(() => {
    if (userRights) {
      console.log("USER RIGHTS", userRights);
    }
  }, []);

  // function for get meeting details
  const getMeeting = (meetingId) => {
    axios.get("/api/meeting/" + meetingId).then(async (response) => {
      if (response && response.status === 200 && response.data) {
        setMeeting(response.data);

        // get twilio room status API - only if room_id exists
        if (response?.data?.room_id) {
          const getStatusUpdate = await axios.get(
            `/internal/get-room-status/${response.data.room_id}`
          );

          SetMeetingBtnStatus(
            getStatusUpdate?.data?.status === "completed" ? false : true
          );
        }
        console.log("DATA RESPONSE123=", response.data);
        // if (response.data.room_id) {
        //   getParticipants(response.data.room_id);
        // }
      }
    }).catch(err => {
      console.log(err)
    })
  };

  const getParticipants = (meetingId) => {
    let searchParams = {
      search: search,
    };
    axios
      .get("/internal/meeting/" + meetingId + "/participant")
      .then(async (response) => {
        if (response && response.status === 200) {
          // console.log(response.data);
          setData(response.data);
        } else {
          throw new Error(response?.error);
        }
      });
  };

  const downloadRecordingFile = (key, roomid) => {
    axios
      .get("/internal/recording/download", { params: { key, roomid } })
      .then(async (response) => {
        if (response && response.status === 200) {
          const link = document.createElement("a");
          link.target = "_blank";
          link.href = response.data.recording_file_url;
          // document.body.appendChild(link);
          link.click();
          // document.body.removeChild(link);
        } else {
          // console.log(response);
          alert("Unable to download recording file");
        }
      });
  };


  const downloadFile = (keyType) => {
    const { meeting_id, room_id, composition_status, record_meeting } = meeting;

    // Only check composition status if recording is enabled
    if (record_meeting && composition_status) {
      // Check if composition is in progress
      if (composition_status === "composition-in-progress" || composition_status === "processing" || composition_status === "composition-enqueued") {
        alert("Recording composition in progress, please check back in some time.");
        return;
      }
    }

    // Only handle recording downloads now
    if (keyType === "recording") {
      axios.get("/api/meeting/" + meeting_id + "/recordings").then(
        async (response) => {
          if (response && response.status === 200 && response.data.length) {
            const { key } = response.data[0];
            downloadRecordingFile(key, room_id);
          } else {
            alert("Unable to download recording file");
          }
        },
        async (error) => {
          alert(error?.response?.data?.message);
        }
      );
    }
  };

  // function for fetch missing details for participants
  const getParticipantsList = async (roomSid) => {
    setIsRefreshing(true);
    let compositionSynced = false;
    try {
      const res = await axios.get(
        `internal/get-disconnected-participant/${roomSid}/${meetingId}`
      );
      compositionSynced = res?.data?.composition_synced === true;
    } catch (error) {
      console.error("Error while getting participant", error);
    } finally {
      // Always refresh meeting and participants regardless of success/error
      getParticipants(meetingId);
      getMeeting(meetingId);
      setIsRefreshing(false);
      if (compositionSynced) {
        setSnackbar({ open: true, message: "Recording is now available! The composition was synced from Twilio.", severity: "success" });
      } else {
        setSnackbar({ open: true, message: "Data refreshed. No new recording update was found.", severity: "info" });
      }
    }
  };

  const columns = [
    // {
    //   field: 'email', headerName: 'Participant Email', width: 200
    // },
    // {
    //   field: 'phone_number', headerName: 'Participant Phone Number', width: 200, sortable: false
    // },
    {
      field: "issue_resolved",
      headerName: "Issue Status",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        // Check if participant has any issue (network issue, issue_reason, or permission issues)
        const hasIssue = params.row.issue_reason ||
          params.row.network_issue ||
          params.row.audio_permission === false ||
          params.row.video_permission === false;

        if (!hasIssue) {
          return null;
        }

        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "6px",
              padding: "0px 20px",
              marginTop: "2px",
              height: "40px",
              fontSize: "13px",
              fontWeight: 500,
              backgroundColor: params.row.issue_resolved === true ? "#22c55e" : "#ef4444",
              color: "white",
              boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            {params.row.issue_resolved === true ? "Issue Resolved" : "Issue Detected"}
          </div>
        );
      },
    },
    {
      field: "identity",
      headerName: "Participant Display Name",
      width: 200,
      // valueGetter: ({ value }) => value ? value.includes('+') ? value.split('###')[1].includes('##') ? value.split('###')[1].split('##')[1] : value.split('###')[1] : value.split('###')[0] : ''
      renderCell: (params) => {
        if (!params?.row?.identity) {
          return "";
        }

        let append = "";
        if (
          (params.row.identity.split("###")[0] === "Chaperoning Mode" ||
            params.row.identity.split("###")[1].startsWith("CP##")) &&
          params.row.audio_enabled
        ) {
          append = " (unmuted)";
        }

        if (params.row.identity.includes("+")) {
          if (params.row.identity.split("###")[1].includes("##")) {
            return params.row.identity.split("###")[1].split("##")[1] + append;
          } else {
            return params.row.identity.split("###")[1] + append;
          }
        } else {
          return params.row.identity.split("###")[0] + append;
        }
      },
    },
    {
      field: "mode",
      headerName: "Mode",
      width: 120,
      sortable: false,
      renderCell: (params) =>
        params?.row?.identity && params.row.identity.includes("###")
          ? params.row.identity.split("###")[0] === "Chaperoning Mode" ||
            params.row.identity.split("###")[1].startsWith("CP##")
            ? "Chaperone"
            : "Normal"
          : "",
    },
    {
      field: "join_time",
      headerName: "Join time (UTC)",
      width: 100,
      sortable: false,
      valueGetter: (params) =>
        params ? moment(params).format("HH:mm") : "NA",
    },
    {
      field: "leave_time",
      headerName: "Leave time (UTC)",
      width: 100,
      sortable: false,
      valueGetter: (params) =>
        params ? moment(params).format("HH:mm") : "NA",
    },
    {
      field: "leave_reason",
      headerName: "Leave Reason",
      width: 140,
      sortable: false,
      valueGetter: (params) => {
        console.log("params", params);
        switch (params) {
          case "manual": return "Left Manually";
          case "inactivity_timeout": return "Auto-kicked";
          case "network_error": return "Network Error";
          case "server_kicked": return "Server Kicked";
          default: return "-";
        }
      },
    },
    {
      field: "join_method",
      headerName: "Join Via",
      width: 120,
      sortable: false,
    },
    { field: "device", headerName: "OS", width: 120, sortable: false },
    { field: "browser", headerName: "Browser", width: 120, sortable: false },
    { field: "location", headerName: "Location", width: 120, sortable: false },
    {
      field: "video",
      headerName: "Video Permission",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        return <>{params.row.video ? <b>Yes</b> : "No"}</>;
      },
    },
    {
      field: "audio",
      headerName: "Audio Permission",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        return <>{params.row.audio ? <b>Yes</b> : "No"}</>;
      },
    },
    {
      field: "screen_share",
      headerName: "Screen Sharing",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        return <>{params.row.screen_share ? <b>Yes</b> : "No"}</>;
      },
    },
    {
      field: "kill_switch_used",
      headerName: "Kill Switch Used",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        const ksv = params.value;
        if (!params.row.identity) {
          return "";
        }

        const identity = params.row.identity.split("###")[0] || "";
        const identifier = params.row.identity.split("###")[1] || "";

        if (ksv === true) {
          return <b>Yes</b>;
        } else if (
          identity === "Chaperoning Mode" ||
          identifier.startsWith("CP##")
        ) {
          return "No";
        } else {
          return "-";
        }
      },
    },
  ];

  /**
   * function for open issue type and reason details
   * Shows panel if participant has any issue: network_issue, issue_reason, or permission issues
   */
  const getDetailPanelContent = useCallback(
    ({ row }) => {
      const hasIssue = row.issue_reason ||
        row.network_issue ||
        row.audio_permission === false ||
        row.video_permission === false;
      return hasIssue ? <InteractionIssue row={row} /> : null;
    },
    []
  );

  return (
    <MainContainer>
      {/* Header Bar */}
      <HeaderBar>
        <HeaderLeft>
          <Link to={"/"} style={{ textDecoration: "none" }}>
            <BackButton>
              ← Back
            </BackButton>
          </Link>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <LogoImage src={logo} alt="Dialectica" />
          </div>
        </HeaderLeft>
        <HeaderRight>
          {/* <HeaderTitle>VIEW INTERACTION</HeaderTitle> */}
          {!meetingBtnStatus && (
            <RefreshButton
              onClick={() => {
                getParticipantsList(meeting?.room_id);
              }}
              disabled={isRefreshing}
            >
              {isRefreshing ? (
                <><CircularProgress size={16} sx={{ color: "#fff", mr: 1 }} /> Refreshing...</>
              ) : (
                <>↻ Refresh Data</>
              )}
            </RefreshButton>
          )}
        </HeaderRight>
      </HeaderBar>

      <ContentWrapper>
        {/* Interaction Overview Card */}
        <OverviewCard elevation={0}>
          <SectionTitle>Interaction Overview</SectionTitle>

          <DetailsGrid>
            {/* Column 1 */}
            <DetailColumn>
              <DetailRow>
                <DetailLabel>TWILIO ID</DetailLabel>
                <DetailValue>{meeting.meeting_id || "-"}</DetailValue>
              </DetailRow>
              <DetailRow>
                <DetailLabel>TOPIC</DetailLabel>
                <DetailValue>{meeting.topic || "-"}</DetailValue>
              </DetailRow>
              <DetailRow>
                <DetailLabel>MAVEN ID</DetailLabel>
                <DetailValue>{meeting.maven_id || "-"}</DetailValue>
              </DetailRow>
              <DetailRow>
                <DetailLabel>MAVEN SOURCE</DetailLabel>
                <DetailValue>{meeting.source || "-"}</DetailValue>
              </DetailRow>
              <DetailRow>
                <DetailLabel>PARTICIPANTS</DetailLabel>
                <DetailValue>{data.length}</DetailValue>
              </DetailRow>
            </DetailColumn>

            {/* Column 2 */}
            <DetailColumn>
              <DetailRow>
                <DetailLabel>MEETING DATE</DetailLabel>
                <DetailValue>
                  {meeting.datetime ? moment(meeting.datetime).format("DD/MM/YYYY") : "-"}
                </DetailValue>
              </DetailRow>
              <DetailRow>
                <DetailLabel>START TIME (UTC)</DetailLabel>
                <DetailValue>
                  {meeting.started_at ? moment(meeting.started_at).format("HH:mm") : "-"}
                </DetailValue>
              </DetailRow>
              <DetailRow>
                <DetailLabel>END TIME (UTC)</DetailLabel>
                <DetailValue>
                  {meeting.ended_at ? moment(meeting.ended_at).format("HH:mm") : "-"}
                </DetailValue>
              </DetailRow>
              <DetailRow>
                <DetailLabel>DURATION</DetailLabel>
                <DetailValue>
                  {meeting.ended_at && meeting.started_at
                    ? meeting.meeting_ended_at
                      ? Math.ceil(
                        moment(meeting.meeting_ended_at).diff(
                          moment(meeting.started_at),
                          "minutes",
                          true
                        )
                      ) + " minute(s)"
                      : Math.ceil(
                        moment(meeting.ended_at).diff(
                          moment(meeting.started_at),
                          "minutes",
                          true
                        )
                      ) + " minute(s)"
                    : "-"}
                </DetailValue>
              </DetailRow>
            </DetailColumn>

            {/* Column 3 */}
            <DetailColumn>
              <DetailRow>
                <DetailLabel>RECORDING</DetailLabel>
                <DetailValue>{meeting.record_meeting ? "Yes" : "No"}</DetailValue>
              </DetailRow>
              <DetailRow>
                <DetailLabel>ANONYMOUS</DetailLabel>
                <DetailValue>{meeting.is_anonymous ? "Yes" : "No"}</DetailValue>
              </DetailRow>
              <DetailRow>
                <DetailLabel>DISCLAIMER</DetailLabel>
                <DetailValue>{meeting.show_disclaimer ? "Yes" : "No"}</DetailValue>
              </DetailRow>
              <DetailRow>
                <DetailLabel>ARCHIVED / DELETED</DetailLabel>
                <DetailValue style={{ display: "flex", gap: "8px" }}>
                  <Badge variant={meeting.is_archived ? "yes" : "no"}>
                    {meeting.is_archived ? "Yes" : "No"}
                  </Badge>
                  <Badge variant={meeting.is_deleted ? "yes" : "no"}>
                    {meeting.is_deleted ? "Yes" : "No"}
                  </Badge>
                </DetailValue>
              </DetailRow>
            </DetailColumn>
          </DetailsGrid>

          {/* Action Buttons */}
          <ButtonGroup>
            <PrimaryButton
              onClick={
                meeting.record_meeting &&
                  userRights.length > 0 &&
                  userRights.includes(TRANSCRIPT_USER)
                  ? () => downloadFile("recording")
                  : () => { }
              }
              disabled={
                !meeting.record_meeting ||
                (userRights.length > 0 && !userRights.includes(TRANSCRIPT_USER))
              }
            >
              <Videocam sx={{ fontSize: 18, mr: 1 }} /> Recording
            </PrimaryButton>

            {meeting.started_at && !meeting.ended_at ? (
              <SecondaryButton href={meeting.join_link} target="_blank">
                <Login sx={{ fontSize: 18, mr: 1 }} /> Join Meeting
              </SecondaryButton>
            ) : (
              <SecondaryButton disabled={true}>
                <Login sx={{ fontSize: 18, mr: 1 }} /> Join Meeting
              </SecondaryButton>
            )}

            {meeting.started_at && !meeting.ended_at ? (
              <a href={meeting.chaperoning_link} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                <SecondaryButton>
                  <Visibility sx={{ fontSize: 18, mr: 1 }} /> Chaperone Meeting
                </SecondaryButton>
              </a>
            ) : (
              <SecondaryButton disabled={true}>
                <Visibility sx={{ fontSize: 18, mr: 1 }} /> Chaperone Meeting
              </SecondaryButton>
            )}
          </ButtonGroup>
        </OverviewCard>

        {/* Participant Overview Card */}
        <ParticipantCard elevation={0}>
          <ParticipantHeader>
            <ParticipantTitle>Participant Overview</ParticipantTitle>
          </ParticipantHeader>

          <DataGridWrapper>
            <DataGridPro
              rows={data}
              columns={columns}
              pageSize={25}
              rowsPerPageOptions={[10, 25, 50]}
              disableSelectionOnClick
              autoHeight={true}
              getDetailPanelContent={getDetailPanelContent}
              getDetailPanelHeight={() => "auto"}
            />
          </DataGridWrapper>

          <div style={{ padding: "8px 16px", fontSize: "13px", color: "#64748b", borderTop: "1px solid #e2e8f0" }}>
            Total Rows: {data.length}
          </div>
        </ParticipantCard>

        {/* View Room Activity Logs Button */}
        <FooterActions>
          <Link to={`/room-logs/${meetingId}`} style={{ textDecoration: "none" }}>
            <ViewLogsButton>
              View Room Activity Logs
            </ViewLogsButton>
          </Link>
        </FooterActions>
      </ContentWrapper>

      {/* Toast Notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={() => setSnackbar(s => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar(s => ({ ...s, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ minWidth: 320 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </MainContainer>
  );
}

